<template>
  <div class="space-y-6">
    <div>
      <div class="text-sm font-semibold text-slate-700">Configuration</div>
      <h2 class="mt-1 text-2xl font-bold tracking-tight text-slate-900">Pricing & settings</h2>
    </div>

    <div class="grid gap-6 lg:grid-cols-2">
      <section class="rounded-2xl bg-white p-5 ring-1 ring-slate-200">
        <div class="text-sm font-bold text-slate-900">Guest hourly rates</div>
        <div class="mt-1 text-xs text-slate-500">Used to calculate guest payments on exit.</div>

        <div class="mt-4 grid gap-4 sm:grid-cols-2">
          <div>
            <label class="text-xs font-semibold text-slate-700">0–1 hour rate (ETB)</label>
            <input v-model.number="firstHourRate" type="number" min="0"
              class="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none ring-sky-200 focus:ring-4" />
          </div>
          <div>
            <label class="text-xs font-semibold text-slate-700">Each extra hour (ETB)</label>
            <input v-model.number="extraHourRate" type="number" min="0"
              class="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none ring-sky-200 focus:ring-4" />
          </div>
        </div>

        <div class="mt-4 rounded-xl bg-slate-50 p-4 text-xs text-slate-600 ring-1 ring-slate-200">
          Example: 0–1hr = <span class="font-semibold text-slate-900">{{ firstHourRate }}</span> ETB,
          additional hour = <span class="font-semibold text-slate-900">{{ extraHourRate }}</span> ETB.
        </div>
      </section>

      <section class="rounded-2xl bg-white p-5 ring-1 ring-slate-200">
        <div class="text-sm font-bold text-slate-900">Policy</div>
        <div class="mt-1 text-xs text-slate-500">How the gate behaves for expired subscriptions.</div>

        <div class="mt-4 flex items-start gap-3 rounded-xl bg-slate-50 p-4 ring-1 ring-slate-200">
          <input id="expiredAsGuest" v-model="treatExpiredAsGuest" type="checkbox" class="mt-0.5 h-4 w-4 rounded border-slate-300 text-sky-600" />
          <label for="expiredAsGuest" class="text-xs text-slate-700">
            <span class="font-semibold">Treat expired permanent users as guest</span>
            <div class="mt-1 text-slate-500">If unchecked, entry is blocked when subscription is expired.</div>
          </label>
        </div>

        <div class="mt-4 flex justify-end">
          <button class="rounded-lg bg-sky-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500" @click="save">
            Save settings
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { toast } from "@/toast";

const store = useStore();

const firstHourRate = ref(Number(store.state.settings.guestPricing.firstHourRate || 20));
const extraHourRate = ref(Number(store.state.settings.guestPricing.extraHourRate || 15));
const treatExpiredAsGuest = ref(Boolean(store.state.settings.treatExpiredPermanentAsGuest));

function save() {
  store.commit("updateSettings", {
    guestPricing: { firstHourRate: Number(firstHourRate.value || 0), extraHourRate: Number(extraHourRate.value || 0) },
    treatExpiredPermanentAsGuest: Boolean(treatExpiredAsGuest.value),
  });
  store.commit("log", {
    action: "update_settings",
    actorId: store.getters.authedUser?.id,
    actorRole: "admin",
    message: "Settings updated.",
  });
  toast.success("Saved.");
}
</script>

